import { FormHelperText, Grid, TextField, Typography } from "@mui/material";
import { AlertContext } from "contexts/Alert";
import { useContext } from "react";
import { BentoCategory, VaNicheSpecificDetails } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

import { makeDeepCopy } from "utils/updateLocalState";

import styles from "../styles";
import PickerDropdown from "./Picker";

interface Props {
  niche: VaNicheSpecificDetails;
  niches: VaNicheSpecificDetails[];
  setNiches: React.Dispatch<React.SetStateAction<VaNicheSpecificDetails[]>>;
  index: number;
  categoriesToPickFrom: BentoCategory[];
}

const Niche = ({
  niche,
  niches,
  setNiches,
  index,
  categoriesToPickFrom,
}: Props) => {
  const { setAlert } = useContext(AlertContext);

  const onChange = (e: CustomEvent) => {
    const { value, name } = e.target;
    const updatedNiches = makeDeepCopy(niches);
    if (name === "bentoCategoryId") {
      const exists = updatedNiches.some(
        (niche: VaNicheSpecificDetails) => niche.bento_category_id === value,
      );
      if (exists) {
        setAlert("You already picked this niche", "warning");
        return;
      }
      updatedNiches[index] = {
        ...updatedNiches[index],
        bento_category_id: value,
        name: categoriesToPickFrom.find((category) => category.id === value)
          ?.name,
      };
    } else {
      updatedNiches[index] = {
        ...updatedNiches[index],
        [name]: value,
      };
    }
    setNiches(updatedNiches);
  };
  return (
    <Grid container alignItems="center" sx={{ mb: 2 }}>
      <Typography variant="h6">
        <strong>Niche {index + 1}</strong>
      </Typography>
      <Grid item xs={12}>
        <FormHelperText>Pick a niche below *</FormHelperText>
        <PickerDropdown
          categoriesToPickFrom={categoriesToPickFrom}
          niche={niche}
          onChange={onChange}
        />
        <FormHelperText>
          Include <strong>ALL details</strong> we will need to pick fitting
          brands for you *
        </FormHelperText>
        <TextField
          sx={styles.textField}
          fullWidth
          name="notes"
          placeholder={
            "For example, how old your kids are; what kind of pet you have; or where in the world you would like to travel"
          }
          onChange={onChange}
          required
          value={niches[index]?.notes || ""}
        />
      </Grid>
    </Grid>
  );
};

export default Niche;
